var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevel9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M1 16.4L30 2L59 16.4V43.4L30 56L1 43.4V16.4Z",
    stroke: "url(#paint0_linear_1266_31050)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1266_31050",
    x1: 57.4395,
    y1: 55.9999,
    x2: 2.82113,
    y2: 56.1652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECC23"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel9);
export default __webpack_public_path__ + "static/media/level-9.1b5af31edf063306fb0cc4383dddf34d.svg";
export { ForwardRef as ReactComponent };